<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col cols="3" class="pr-2" v-show="filtersVisible">
                <AnalysisFiltersCard/>
            </v-col>

            <v-col :cols="filtersVisible ? 9 : 12">
                <AnalysisChartRow v-if="firstLoadingDone"/>
                <AnalysisTableRow v-if="firstLoadingDone"/>
                <AnalysisProductTableRow v-if="firstLoadingDone"/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import AnalysisFiltersCard from "./sections/analysis-filters-card.vue";
import AnalysisStatRow from "./sections/analysis-stat-row.vue";
import AnalysisChartRow from "./sections/analysis-chart-row.vue";
import AnalysisTableRow from "./sections/analysis-table-row.vue";
import AnalysisProductTableRow from "./sections/analysis-product-table-row.vue";

export default {
    name: "analysis-view",
    components: {
        AnalysisTableRow,
        AnalysisChartRow,
        AnalysisStatRow,
        AnalysisFiltersCard,
        AnalysisProductTableRow
    },
    computed: {
        ...mapState("AnalysisStore", ["filtersVisible", "filters", "firstLoadingDone"]),
    },
};
</script>

<style scoped></style>
